import { Button } from '@components'
import { useBusinessContext } from '@context'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import ifInsuranceImgSrc from '@assets/if-insurance.svg'

import { sendIfInsuranceForm } from '@root/query/ifInsurance'
import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import theme from '@root/styles/theme'
import {
  ActionBar,
  LogoContainer,
  StyledButton,
  StyledImg,
  StyledPageContent,
  StyledText
} from './if.styled'

interface Props {
  onSuccess: () => void
}

export const IfInsuranceSend: React.FC<Props> = ({ onSuccess }) => {
  const history = useHistory()
  const [t] = useTranslation()
  const { slug } = useBusinessContext()

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: () => sendIfInsuranceForm({ slug }),
    ...{
      onSuccess: () => {
        toast.success(t('general.success'))
        onSuccess()
      },
      onError: () => {
        toast.error(t('general.error'))
      }
    }
  })

  return (
    <StyledPageContent>
      <LogoContainer>
        <StyledImg src={ifInsuranceImgSrc} alt="If Insurance" />
      </LogoContainer>

      <div>
        <h4>{t('ifInsurancePage.contactForm.header')}</h4>
        <StyledText>{t('ifInsurancePage.contactForm.description')}</StyledText>
        <StyledText>{t('ifInsurancePage.contactForm.description2')}</StyledText>
      </div>

      <ActionBar>
        <Button onClick={() => history.goBack()} style={{ marginRight: `${theme.spacing.md}rem` }}>
          {t('general.cancel')}
        </Button>
        <StyledButton
          intent="success"
          onClick={() => mutate()}
          showSpinner={isLoading}
          disabled={isLoading}
        >
          {t('ifInsurancePage.contactForm.send')}
        </StyledButton>
      </ActionBar>
    </StyledPageContent>
  )
}
